module.exports = __webpack_public_path__ + "static/media/online-learning-illustration.ae5ae306.png";